














































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      wrongLogin: false,
      uname: "",
      pw: "",
      focused: ""
    };
  },
  props: {
    wrong: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loginMessage: {
      type: String,
      default: "Felaktigt användarnamn/lösenord"
    }
  },
  methods: {
    login: async function(): Promise<void> {
      this.$emit("login", { username: this.uname, password: this.pw });
      // this.wrongLogin = false;
      // if (
      //   await this.$store.dispatch("login", {
      //     username: this.uname,
      //     password: this.pw
      //   })
      // ) {
      //   if (this.$store.getters.isAdmin) {
      //     this.$router.push({ name: "admin" });
      //   } else {
      //     this.$router.push({ name: "mypage" });
      //   }
      // } else {
      //   this.wrongLogin = true;
      // }
    },
    focus: function(input: string): void {
      this.focused = input;
    }
  }
});
